import { render } from "./ProductDropdown.vue?vue&type=template&id=22481a3b&scoped=true"
import script from "./ProductDropdown.vue?vue&type=script&lang=js"
export * from "./ProductDropdown.vue?vue&type=script&lang=js"

import "./ProductDropdown.vue?vue&type=style&index=0&id=22481a3b&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22481a3b"]])

export default __exports__